import {BehaviorSubject, Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {AuthService} from "../../../../modules/auth/api/service/auth.service";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: "root",
})
export class DeviceService {

    serialNumber$: Observable<string> = new BehaviorSubject<string>(undefined);

    constructor(private authService: AuthService,
                private httpClient: HttpClient) {
        const serialNumber = window.localStorage.getItem("serialNumber");
        if (serialNumber) {
            (this.serialNumber$ as  BehaviorSubject<string>).next(serialNumber);
        }
    }

    set serialNumber(value: string) {
        window.localStorage.setItem('serialNumber', value);
        (this.serialNumber$ as  BehaviorSubject<string>).next(value);
    }

    get serialNumber(): string {
        return window.localStorage.getItem('serialNumber');
    }

    set secretToken(value: string) {
        window.localStorage.setItem('secretToken', value);
    }

    get secretToken(): string {
        return window.localStorage.getItem('secretToken');
    }
}